/*
  Which treated plate belongs to a circle.

  Circles carry a free-text medium ("Writers", "Songwriters", "Printmakers"),
  so we match on what the words suggest rather than an enum. If nothing
  matches we show no picture at all — an honest blank beats the wrong craft.

  The images themselves are photographs put through the duotone treatment in
  backend/tools/treat_photos.py, so they read as texture in the page's own ink
  and parchment rather than as stock photography.
*/
const PLATES = [
  {
    test: /writ|poet|essay|script|lyric|story|fiction|novel|play|word/i,
    file: "desk",
    alt: "A writing desk with inkwells and papers, in ink and parchment.",
  },
  {
    test: /music|song|compos|instrument|choir|band|sing|string|jazz|hymn/i,
    file: "instrument",
    alt: "The body of a violin, in ink and parchment.",
  },
  {
    test: /paint|draw|illustrat|print|visual|photo|sculpt|film|art/i,
    file: "studio",
    alt: "A painter's studio with canvases and jars, in ink and parchment.",
  },
  {
    test: /danc|ballet|choreo|movement|body/i,
    file: "dance",
    alt: "A dancer's skirt caught mid-turn, in ink and parchment.",
  },
  {
    test: /culinar|cook|food|kitchen|bake|bread|chef|pastry|brew/i,
    file: "culinary",
    alt: "Three rustic loaves and a head of wheat, in ink and parchment.",
  },
  {
    test: /craft|maker|wood|textile|ceramic|design|build|architect|metal|bind/i,
    file: "workshop",
    alt: "A workshop wall hung with hand tools, in ink and parchment.",
  },
];

export function craftPlate(...hints) {
  const text = hints.filter(Boolean).join(" ");
  const match = PLATES.find((p) => p.test.test(text));
  if (!match) return null;
  return { src: `/brand/crafts/${match.file}.png`, alt: match.alt };
}

export default craftPlate;
